import React from "react";
import { withPublicUrl } from "../api/config";
import { EVENT_LOCATION } from "../constants/eventDetails";

const FaqSection = () => {
  const faqBackgroundStyle = {
    backgroundColor: "#02050b",
    backgroundImage: `linear-gradient(135deg, rgba(0, 0, 0, 0.9) 0%, rgba(3, 8, 18, 0.84) 45%, rgba(11, 17, 31, 0.88) 100%), url(${withPublicUrl(
      "/assets/images/background/faq-market-bg.jpeg"
    )})`,
    backgroundPosition: "center center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundAttachment: "fixed",
    paddingTop: "110px",
    paddingBottom: "110px",
  };

  const glassCardStyle = {
    background: "rgba(255, 255, 255, 0.95)",
    border: "1px solid rgba(255, 255, 255, 0.16)",
    boxShadow: "0 24px 60px rgba(3, 8, 20, 0.28)",
    backdropFilter: "blur(10px)",
  };

  const formCardStyle = {
    background: "linear-gradient(180deg, rgba(7, 13, 24, 0.96) 0%, rgba(10, 19, 34, 0.94) 100%)",
    border: "1px solid #E91E8C",
    boxShadow: "0 24px 60px rgba(0, 0, 0, 0.38)",
    backdropFilter: "blur(10px)",
  };

  const formFieldStyle = {
    background: "rgba(255, 255, 255, 0.06)",
    border: "1px solid rgba(233, 30, 140, 0.28)",
    color: "#ffffff",
  };

  const formCopyStyle = {
    color: "rgba(255, 255, 255, 0.78)",
  };

  return (
    <>
      <style>
        {`
          .faq-form input::placeholder,
          .faq-form textarea::placeholder {
            color: rgba(255, 255, 255, 0.6);
          }

          .faq-form input:focus,
          .faq-form textarea:focus {
            border-color: #E91E8C;
            box-shadow: 0 0 0 3px rgba(233, 30, 140, 0.12);
          }
        `}
      </style>
      <section
        className="faq pb-0 overflow-visible d-block position-relative z-1"
        style={faqBackgroundStyle}
      >
        <div className="container">
          <div>
            <div className="row">
              <div className="col-lg-6 px-4 mb-2">
                <div className="faq-general">
                  <div className="section-title pb-3 text-center text-lg-start">
                    <p className="mb-1 pink">GENERAL QUESTIONS</p>
                    <h2 className="mb-2 text-white">
                      FREQUENTLY ASKED <span className="pink">QUESTIONS</span>
                    </h2>
                    <p className="text-white">
                      Answers to common questions about <b>PROFINEXPO BANGKOK 2026</b>
                    </p>
                  </div>
                  <div
                    className="faq-accordion faq-accordion-pro p-4 mb-5 rounded"
                    style={glassCardStyle}
                  >
                    <div className="accordion accordion-faq" id="accordionFlushExample">

                      <div className="accordion-item">
                        <p className="accordion-header p-4">
                          <button
                            className="accordion-button collapsed fw-semibold p-0"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#flush-collapseOne"
                            aria-expanded="false"
                            aria-controls="flush-collapseOne"
                          >
                            Is entry free?
                          </button>
                        </p>
                        <div
                          id="flush-collapseOne"
                          className="accordion-collapse collapse"
                          data-bs-parent="#accordionFlushExample"
                        >
                          <div className="accordion-body p-6">
                            Yes, entry to <b>PROFINEXPO BANGKOK 2026</b> is completely free for all attendees.
                          </div>
                        </div>
                      </div>

                      <div className="accordion-item">
                        <p className="accordion-header p-4">
                          <button
                            className="accordion-button collapsed fw-semibold p-0"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#flush-collapseTwo"
                            aria-expanded="false"
                            aria-controls="flush-collapseTwo"
                          >
                            Where is the event located?
                          </button>
                        </p>
                        <div
                          id="flush-collapseTwo"
                          className="accordion-collapse collapse"
                          data-bs-parent="#accordionFlushExample"
                        >
                          <div className="accordion-body p-6">
                            {EVENT_LOCATION}.
                          </div>
                        </div>
                      </div>

                      <div className="accordion-item">
                        <p className="accordion-header p-4">
                          <button
                            className="accordion-button collapsed fw-semibold p-0"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#flush-collapseThree"
                            aria-expanded="false"
                            aria-controls="flush-collapseThree"
                          >
                            Who can attend?
                          </button>
                        </p>
                        <div
                          id="flush-collapseThree"
                          className="accordion-collapse collapse"
                          data-bs-parent="#accordionFlushExample"
                        >
                          <div className="accordion-body p-6">
                            Anyone from the finance, trading, FinTech, blockchain, and technology sectors.
                          </div>
                        </div>
                      </div>

                      <div className="accordion-item">
                        <p className="accordion-header p-4">
                          <button
                            className="accordion-button collapsed fw-semibold p-0"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#flush-collapseFour"
                            aria-expanded="false"
                            aria-controls="flush-collapseFour"
                          >
                            Will there be exhibition booths?
                          </button>
                        </p>
                        <div
                          id="flush-collapseFour"
                          className="accordion-collapse collapse"
                          data-bs-parent="#accordionFlushExample"
                        >
                          <div className="accordion-body p-6">
                            Yes, live exhibition booths will be available throughout the summit.
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-6  align-self-center px-4">
                <div
                  className="faq-form rounded shadow-lg p-6 mb-mi"
                  style={formCardStyle}
                >
                  <div className="form-title mb-4">
                    <p className="mb-1 pink">TICKET BOOK</p>
                    <h2 className="mb-2 text-white">
                      LET'S RESERVE A <span className="pink">SEAT</span>
                    </h2>
                    <p className="m-0" style={formCopyStyle}>
                      Book your tickets to the <b>PROFINEXPO BANGKOK 2026</b> now!!
                    </p>
                  </div>
                  <div className="form-content justify-content-between">
                    <form>
                      <input
                        type="text"
                        placeholder="Full Name"
                        className="mb-5"
                        style={formFieldStyle}
                      />
                      <div className=" row justify-content-around">
                        <div className="col-lg-6 col-md-6">
                          <div className="phone-no">
                            <input
                              type="tel"
                              placeholder="Phone No."
                              className="mb-5"
                              style={formFieldStyle}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6">
                          <div className="emai">
                            <input
                              type="email"
                              placeholder="Email Address"
                              className="mb-5"
                              required
                              style={formFieldStyle}
                            />
                          </div>
                        </div>
                      </div>
                      <textarea
                        placeholder="How may we help you?"
                        rows="4"
                        className="mb-5"
                        style={formFieldStyle}
                      ></textarea>
                      <button className="btn mb-5" id="sub-btn">
                        SEND MESSAGE
                      </button>
                    </form>
                    <small style={formCopyStyle}>
                      We respect your privacy. Your information is safe with us.
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FaqSection;
